"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var FooterList = function (_a) {
    var title = _a.title, list = _a.list;
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var website = (0, swr_hooks_1.useBrand)().website;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("span", null, title),
        react_1.default.createElement("ul", null, list.map(function (item, idx) {
            return (react_1.default.createElement("li", { key: idx }, (item === null || item === void 0 ? void 0 : item.onlyDirectLink) === true ? (react_1.default.createElement("a", { href: (item === null || item === void 0 ? void 0 : item.withDomain) ? "".concat(item.link).concat(website) : item.link }, t("".concat(item.linkName)))) : (react_1.default.createElement("a", { href: generateUrlWithLang(item.link) }, t("".concat(item.linkName))))));
        }))));
};
exports.default = FooterList;
